<template>
  <Header />
  <router-view />
</template>

<script setup>
import Header from "@/components/header.vue"
import { useCoinStore } from "@/store"
const coinStore = useCoinStore();

coinStore.init();

</script>

<style lang="scss">
@import url('./styles/index.scss');
@font-face {
  font-family: 'Poppins-Regular';
  src: url('@/assets/fonts/Poppins-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: Poppins-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  background-color: $bg;
  line-height: 1.5;
  color: $black;
  font-size: 14px;
  display: flex;
  flex-direction: column;
}

* {
  padding: 0;
  margin: 0;
  :focus-visible{
    outline: unset;
  }
}

html,
body {
  height: 100%;
}

body {
  background-color: $bg;
}
</style>
